import WxTemplatePushManagement from './WxTemplatePushManagement.vue'

export default WxTemplatePushManagement


// WEBPACK FOOTER //
// ./src/pages/WxTemplatePushManagement/index.js